// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartitems{
    margin: 100px 170px;
}
.cartitems hr{
    height: 3px;
    background: #e2e2e2;
    border: 0;
}
.cartitems-format-main{
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr 1fr;
    align-items: center;
    gap: 75px;
    padding: 20px 0px;
    color: #454545;
    font-size: 18px;
    font-weight: 600;
}
.cartitems-format{
    font-size: 17px;
    font-weight: 500;
}
.carticon-product-icon{
    height: 62px; 
}
.cartitems-remove-icon{
    width: 15px;
    margin: 0px 40px;
    cursor: pointer;
}
.cartitems-quantity{
    width: 64px;
    height: 50px;
    border: 2px solid #ebebeb;
    background: #fff;
}
.cartitems-down{
    display: flex;
    margin: 100px 0px;
}
.cartitems-total{
    flex: 1 1;
    display: flex;
    flex-direction: column;
    margin-right: 200px;
    gap: 40px;

}
.cartitems-total-items{
    display: flex;
    justify-content: space-between;
    padding: 15px 0px;
}
.cartitems-total button{
    width: 262px;
    height: 58px;
    outline: none;
    border: none;
    background: #ff5a5a;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}
.cartitems promocode{
    flex: 1 1;
    font-size: 16px;
    font-weight: 500;
}
.cartitems-promocode p{
    color: #555;
}
.cartitems-promobox{
    width: 504px;
    margin-top: 15px;
    padding-left: 20px;
    height: 58px;
    background: #eaeaea;
}
.cartitems-promobox input{
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    width: 330px;
    height: 50px;

}
.cartitems-promobox button{
    width: 170px;
    height: 58px;
    font-size: 16px;
    background: black;
    color: white;
    cursor: pointer;
}

@media(max-width:1280px){
    .cartitems{
        margin: 60px 50px;

    }
    .cartitems-format-main{
        grid-template-columns: 0.5fr 3fr 0.5fr 0.5fr 0.5fr 0.5fr;
        gap: 20px;
        padding: 15px 0px;
        font-size: 15px;
    }
    .carticon-product-icon{
        height: 50px;
    }
    .cartitems-remove-icon{
        margin: auto;
    }
    .cartitems-quantity{
        width: 40px;
        height: 30px;
    }
    .cartitems-down{
        margin: 80px 0px;
        flex-direction: column;
        gap: 80px;
    }
    .cartitems-total{
        margin: 0;
    }
    .cartitems-total button{
        max-width: 200px;
        height: 45px;
        font-size: 13px;
    }
    .cartitems-promobox{
        width: auto;
        max-width: 500px;
    }
    .cartitems-promobox input{
        width: 100%;
    }
    .cartitems-promobox button{
        width: 120px;
        margin-left: -125px;
    }

}
@media(max-width:500px){
    .cartitems-format-main{
        display: none;
        grid-template-columns: 0.5fr 0.3fr 0.5fr;
        gap: 10px;

    }
    .cartitems-format{
        display: grid;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Cartitems/Cartitems.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;;AAEb;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,YAAY;;AAEhB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;;IAErB;IACA;QACI,wDAAwD;QACxD,SAAS;QACT,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,mBAAmB;IACvB;;AAEJ;AACA;IACI;QACI,aAAa;QACb,wCAAwC;QACxC,SAAS;;IAEb;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".cartitems{\n    margin: 100px 170px;\n}\n.cartitems hr{\n    height: 3px;\n    background: #e2e2e2;\n    border: 0;\n}\n.cartitems-format-main{\n    display: grid;\n    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr 1fr;\n    align-items: center;\n    gap: 75px;\n    padding: 20px 0px;\n    color: #454545;\n    font-size: 18px;\n    font-weight: 600;\n}\n.cartitems-format{\n    font-size: 17px;\n    font-weight: 500;\n}\n.carticon-product-icon{\n    height: 62px; \n}\n.cartitems-remove-icon{\n    width: 15px;\n    margin: 0px 40px;\n    cursor: pointer;\n}\n.cartitems-quantity{\n    width: 64px;\n    height: 50px;\n    border: 2px solid #ebebeb;\n    background: #fff;\n}\n.cartitems-down{\n    display: flex;\n    margin: 100px 0px;\n}\n.cartitems-total{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    margin-right: 200px;\n    gap: 40px;\n\n}\n.cartitems-total-items{\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 0px;\n}\n.cartitems-total button{\n    width: 262px;\n    height: 58px;\n    outline: none;\n    border: none;\n    background: #ff5a5a;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.cartitems promocode{\n    flex: 1;\n    font-size: 16px;\n    font-weight: 500;\n}\n.cartitems-promocode p{\n    color: #555;\n}\n.cartitems-promobox{\n    width: 504px;\n    margin-top: 15px;\n    padding-left: 20px;\n    height: 58px;\n    background: #eaeaea;\n}\n.cartitems-promobox input{\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 16px;\n    width: 330px;\n    height: 50px;\n\n}\n.cartitems-promobox button{\n    width: 170px;\n    height: 58px;\n    font-size: 16px;\n    background: black;\n    color: white;\n    cursor: pointer;\n}\n\n@media(max-width:1280px){\n    .cartitems{\n        margin: 60px 50px;\n\n    }\n    .cartitems-format-main{\n        grid-template-columns: 0.5fr 3fr 0.5fr 0.5fr 0.5fr 0.5fr;\n        gap: 20px;\n        padding: 15px 0px;\n        font-size: 15px;\n    }\n    .carticon-product-icon{\n        height: 50px;\n    }\n    .cartitems-remove-icon{\n        margin: auto;\n    }\n    .cartitems-quantity{\n        width: 40px;\n        height: 30px;\n    }\n    .cartitems-down{\n        margin: 80px 0px;\n        flex-direction: column;\n        gap: 80px;\n    }\n    .cartitems-total{\n        margin: 0;\n    }\n    .cartitems-total button{\n        max-width: 200px;\n        height: 45px;\n        font-size: 13px;\n    }\n    .cartitems-promobox{\n        width: auto;\n        max-width: 500px;\n    }\n    .cartitems-promobox input{\n        width: 100%;\n    }\n    .cartitems-promobox button{\n        width: 120px;\n        margin-left: -125px;\n    }\n\n}\n@media(max-width:500px){\n    .cartitems-format-main{\n        display: none;\n        grid-template-columns: 0.5fr 0.3fr 0.5fr;\n        gap: 10px;\n\n    }\n    .cartitems-format{\n        display: grid;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
